import React from 'react';

import Button from "react-bootstrap/Button";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

//import PartImage from "../../assets/images/Test-Part.png";
import PartImage from "../../assets/images/part-thumbnail.svg";
import PlaceOrder from "../PlaceOrder/PlaceOrder";

import "./generateQuote.scss";

//import html2pdf from 'html2pdf.js';
import html2pdf from 'html2pdf.js/dist/html2pdf.min.js';

import { generateCostEstimate } from "../../services/part/partService";

import { useParams } from "react-router-dom";

interface Window {
  showSaveFilePicker(options?: {
    suggestedName?: string;
    types?: {
      description?: string;
      accept: Record<string, string[]>;
    }[];
  }): Promise<FileSystemFileHandle>;
}

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}) => {

  const radius =
    innerRadius + (outerRadius - innerRadius) * 0.5;

  const x =
    cx + radius * Math.cos(-midAngle * (Math.PI / 180));

  const y =
    cy + radius * Math.sin(-midAngle * (Math.PI / 180));

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

class GenerateQuotePage extends React.Component<any, any> {

  constructor(props: any) {

    super(props);

    this.state = {
      showDetailedBreakdown: false,
      quantity: 2,
      showPlaceOrder: false,
      costData: null,
      loading: true
    };
  }

 
  async componentDidMount() {

    try {
  

  
      if (this.props.costData) {
  
        this.setState({
          costData: this.props.costData,
          loading: false
        });
  
        return;
      }
  

  
      const response =
        await generateCostEstimate(
          this.props.partId
        );
  
      this.setState({
        costData: response.costBreakdown,
        loading: false
      });
  
    } catch (error) {
  
      console.error(
        "COST ESTIMATION ERROR:",
        error
      );
  
      this.setState({
        loading: false
      });
    }
  }

  handleQuantityChange = (e: any) => {

    const value = parseInt(e.target.value) || 0;

    this.setState({
      quantity: value
    });
  };

  toggleDetailedBreakdown = () => {

    this.setState({
      showDetailedBreakdown:
        !this.state.showDetailedBreakdown
    });
  };

  exportToPDF = async () => {

    const fileName = 'Quote Result.pdf';

    const element =
      document.getElementById('quote-results');

    if (!element) return;

    html2pdf()
      .from(element)
      .toPdf()
      .output('blob')
      .then(async (blob) => {

        const fileHandle =
          await (window as any).showSaveFilePicker({
            suggestedName: fileName,
            types: [
              {
                description: 'PDF Files',
                accept: {
                  'application/pdf': ['.pdf'],
                },
              },
            ],
          });

        const writable =
          await fileHandle.createWritable();

        await writable.write(blob);

        await writable.close();
      });
  };

  handleBackToDashboard = () => {

    window.location.href = '/dashboard';
  };

  handlePlaceOrder = () => {

    this.setState({
      showPlaceOrder: true
    });
  };

  handleBackFromPlaceOrder = () => {

    this.setState({
      showPlaceOrder: false
    });
  };

  public render() {

    if (this.state.loading) {

      return <div>Generating Quote...</div>;
    }

    const costData = this.state.costData;

    if (!costData) {

      return <div>Unable to generate quote.</div>;
    }

    const data = [
      {
        name: "Printing",
        value: costData.printerCost
      },
      {
        name: "Sintering",
        value: costData.furnaceCost
      },
      {
        name: "Accessories",
        value: costData.accessoriesCost
      },
      {
        name: "Material",
        value: costData.pasteCost
      },
      {
        name: "Labor",
        value: costData.laborCost
      },
      {
        name: "Consumables",
        value: costData.consumableCost
      },
      {
        name: "Maintenance",
        value: costData.maintenanceCost
      }
    ];

    const COLORS = [
      '#B54B00',
      '#FF8733',
      '#FF6900',
      '#E86000',
      '#8C3A00',
      '#6B2C00',
      '#1F2A37'
    ];

    const perPartCost = costData.totalCost;

    const quantity = this.state.quantity;

    const quantityCost =
      perPartCost * quantity;

    const overallCost = quantityCost;

    if (this.state.showPlaceOrder) {

      return (
        <PlaceOrder
          totalAmount={overallCost}
          onBack={this.handleBackFromPlaceOrder}
        />
      );
    }

    return (
      <>
        

        <div className="quote-content-wrapper">

          <div className="quote-summary-card">

            <div className="quote-part-image">

            <img
              src={
                this.props.previewImage || PartImage
              }
              alt="Part Preview"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain'
              }}
            />

            </div>

            <div className="quote-info-section">

            <div
                style={{
                  display: 'flex',
                  gap: '40px',
                  marginBottom: '20px',
                  color: '#1F2937',
                  fontWeight: 600,
                  fontSize: '16px'
                }}
              >

                <div>

                  Estimated Paste:
                  <span
                    style={{
                      marginLeft: '8px',
                      color: '#FF6900'
                    }}
                  >
                    {Math.round(Number(
                      costData.PasteEstimation ||
                      costData.pasteEstimation ||
                      0
                    ))} mL
                  </span>

                </div>

                <div>

                  Estimated Time:
                  <span
                    style={{
                      marginLeft: '8px',
                      color: '#FF6900'
                    }}
                  >
                    {Math.round(costData.printTimeHours)} hrs
                  </span>

                </div>

              </div>

              <div className="cost-breakdown-table">

                <div className="cost-row overall-row">

                  <label>Per Part Cost</label>

                  <label>
                    ${Math.round(perPartCost)}
                  </label>

                </div>

                {/*<div className="cost-row quantity-row">

                  <label>Quantity</label>

                  <div className="quantity-input-group">

                    <input
                      type="number"
                      min="1"
                      value={quantity}
                      onChange={this.handleQuantityChange}
                      className="quantity-input"
                    />

                    <label>
                      $ {quantityCost.toFixed(2)}
                    </label>

                  </div>

                  </div>

                <div className="cost-divider"></div>

                <div className="cost-row overall-row">

                  <label>Total Cost</label>

                  <label>
                    $ {overallCost.toFixed(2)}
                  </label>

                </div>*/}

                <div className="cost-divider-thick"></div>

              </div>

              {/*<div*/}
              {/*  className="view-breakdown-link"*/}
              {/*  onClick={this.toggleDetailedBreakdown}*/}
              {/*>*/}

              {/*  View Cost Breakdown*/}

              {/*  {this.state.showDetailedBreakdown*/}
              {/*    ? <ExpandMoreIcon />*/}
              {/*    : <ChevronRightIcon />*/}
              {/*  }*/}

              {/*</div>*/}

            </div>

          </div>

          {this.state.showDetailedBreakdown && (

            <div
              className="quote-breakdown-section"
              id="quote-results"
            >

              <h3 style={{ marginBottom: '20px' }}>
                Per Part Detailed Cost Breakdown
              </h3>

              <div
                style={{
                  display: 'flex',
                  marginBottom: '30px'
                }}
              >

            <div className="chart-container">

            <PieChart width={500} height={500}>

              <Tooltip
                formatter={(value: any, name: any, props: any) => {

                  const total = data.reduce(
                    (sum, item) => sum + item.value,
                    0
                  );

                  const percentage =
                    Math.round((value / total) * 100);

                  return [
                    `$${Math.round(value)} (${percentage}%)`,
                    name
                  ];
                }}
              />

              <Pie
                dataKey="value"
                isAnimationActive={false}
                data={data}
                cx="50%"
                cy="50%"
                outerRadius={170}
                fill="#8884d8"
                startAngle={45}
                endAngle={405}
                labelLine={false}
                label={({ percent }) =>
                  percent > 0.05
                    ? `${Math.round(percent * 100)}%`
                    : ""
                }
              >
                

                  {data.map((entry, index) => (

                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />

                  ))}

                </Pie>

                <Tooltip />

              </PieChart>

            </div>

            <div className="legend-container">

              {data.map((item, index) => (

                <div
                  className="legend"
                  key={index}
                >

                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >

                    <div
                      className="display-status"
                      style={{
                        backgroundColor:
                          COLORS[index % COLORS.length]
                      }}
                    ></div>

                    <p className="display-text">
                      {item.name}
                    </p>

                  </div>

                  <p className="display-percentage">
                    ${Math.round(item.value)}
                  </p>

                </div>

              ))}

            </div>

          </div>

            </div>
          )}

          {!this.props.hideActions && (
          <div className="quote-action-buttons">

            <Button
              className="btn-back-dashboard"
              variant="secondary"
              onClick={this.handleBackToDashboard}
            >

              Back To Dashboard

            </Button>

            <Button
              className="btn-place-order"
              variant="primary"
              onClick={this.handlePlaceOrder}
            >

              Place Order

            </Button>

          </div>

          )}

        </div>
      </>
    );
  }
}

function GenerateQuotePageWrapper(props) {

  const params = useParams();

  return (
    <GenerateQuotePage
      {...props}
      partId={
        props.partId || params.partId
      }
      hideActions={true}
    />
  );
}

export default GenerateQuotePageWrapper;
